module.exports = __webpack_public_path__ + "static/sectionbefore-9cd9abef2dab3165bde95dc0a095bd2b.png";